
// ページネーションレンダリング関数
function renderPagination(current_page, max_page, url_root, url_params, selector){
  let paginationHtml = "";
  if(current_page > 1){
    paginationHtml += `
      <span class="prev">
        <a href="${url_root + `?page=${current_page-1}&` + url_params.toString()}" title="{{ 'general.pagination.previous' | t }}">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"/></svg>
          <span class="icon__fallback-text">{{ 'general.pagination.previous' | t }}</span>
        </a>
      </span>
      `;
  }
  if(current_page === 1){
    paginationHtml += `
      <span class="page current">1</span>
    `;
  } else {
    paginationHtml += `
      <span class="page">
        <a href="${url_root + `?page=1&` + url_params.toString()}">1</a>
      </span>
    `;
  }
  if(current_page >= 5){
    paginationHtml += `
      <span class="page">…</span>
    `;
  }
  for(let i=current_page-2; i<=current_page+2; i++){
    if(i <= 1 || i >= max_page){
      continue;
    }
    if(i === current_page){
      paginationHtml += `
        <span class="page current">${i}</span>
      `;
    } else {
      paginationHtml += `
        <span class="page">
          <a href="${url_root + `?page=${i}&` + url_params.toString()}">${i}</a>
        </span>
      `;
    }
  }
  if(current_page <= max_page-4){
    paginationHtml += `
      <span class="page">…</span>
    `;
  }
  if(max_page != 1){
    if(current_page === max_page){
      paginationHtml += `
        <span class="page current">${max_page}</span>
      `;
    } else {
      paginationHtml += `
        <span class="page">
          <a href="${url_root + `?page=${max_page}&` + url_params.toString()}">${max_page}</a>
        </span>
      `;
    }
  }
  if(current_page+1 <= max_page){ 
    paginationHtml += `
      <span class="next">
        <a href="${url_root + `?page=${current_page+1}&` + url_params.toString()}" title="{{ 'general.pagination.next' | t }}">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"/></svg>
          <span class="icon__fallback-text">{{ 'general.pagination.next' | t }}</span>
        </a>
      </span>
    `;
  }
  let pagination_el = document.querySelector(selector);
  if(pagination_el){
    pagination_el.innerHTML = paginationHtml;
  }
}

// バリエーション変更
function variantChanged(current, variants) {
  if(!current){
    return;
  }
  const metafields = current.metafields;

  // 商品特殊表示
  let shipping_date_limit = false;
  const special_word = document.querySelector('[data-special-word]');
  if(special_word && metafields){
    special_word.innerHTML = "";
    special_word.classList.remove("inventory--low");
    const inventoryThreshold = special_word.dataset?.inventoryThreshold;  
    let is_line_item_property = false;
    if(metafields.ec_special_word){
      special_word.innerHTML = `${metafields.ec_special_word}`;
      is_line_item_property = true;
    } else {
      if(parseInt(special_word.dataset.productIsIem) > 0){
        shipping_date_limit = true;
        if(metafields.prod_rank === "終"){
          special_word.innerHTML = "生産終了品の為、在庫限り！";
          is_line_item_property = true;
        } else {
          special_word.innerHTML = `○在庫あり`;
        }
      } else if(current.inventory_quantity > 0){
        shipping_date_limit = true;
        if(metafields.prod_rank === "終"){
          special_word.innerHTML = "生産終了品の為、在庫限り！";
          is_line_item_property = true;
        } else {
          if(special_word.dataset.productType === "中古"){
            special_word.innerHTML = `中古品につき、1点限り`;
            is_line_item_property = true;
          } else {
            if(current.inventory_quantity > inventoryThreshold) {
              special_word.innerHTML = `○在庫あり`;
            } else {
              special_word.classList.add("inventory--low");
              special_word.innerHTML = `△残りわずか`;
            }
          }
        }
      } else {
        let upper_limit_reservation = parseInt(metafields.upper_limit_reservation ? metafields.upper_limit_reservation : "0");
        let reservation_sold = parseInt(metafields.reservation_sold ? metafields.reservation_sold : "0");
        let available_reservations = upper_limit_reservation - reservation_sold;
        if(available_reservations >= 1){
          if(metafields.prod_rank === "取"){
            special_word.innerHTML = "お取り寄せ受付中";
            is_line_item_property = true;
          } else {
            special_word.innerHTML = "ご予約受付中";
            is_line_item_property = true;
          }
        } else {
          special_word.innerHTML = "×在庫なし";
        }
      }
    }
    if(special_word.innerHTML !== "" && is_line_item_property){
      special_word.innerHTML += `<input form="${special_word.dataset?.formId}" type="hidden" name="properties[商品特殊表示]" value="${special_word.innerHTML}"></input>`;
    }
  }

  // 店舗別在庫状況
  productStockOfShop(current, variants, shipping_date_limit);

  // ポイント更新
  updatePoint(current);

  // 延長保証金額更新
  updateExtendedWarranty(current);

  //ここに値を追加
  const target2 = document.querySelector('[data-warranty]');

  if (target2 && metafields.prod_warranty_period && metafields.prod_warranty_period !== "n/a") {
    const replacements = {
      "HY": "半年",
      "Y": "年",
      "M": "ヶ月",
      "D": "日",
      "FE": "永年",
      "NO": "不可"
    };

    let warrantyText = metafields.prod_warranty_period;

    for (const [key, value] of Object.entries(replacements)) {
      if (warrantyText.includes(key)) {
        warrantyText = warrantyText.replace(key, value);
        break;
      }
    }

    target2.innerHTML = warrantyText;
  } else if (target2) {
    target2.innerHTML = "無し";
  }

  // 発売日情報表示
  const release_note = document.querySelector('[data-release_note]');
  if (release_note){
    if(metafields.release_note) {
      release_note.innerHTML = metafields.release_note;
    } else {
      release_note.innerHTML = "";
    }
  } 

  //買取価格
  const parchase_price_block = document.querySelector('[data-parchase_price_block]');   
  const max_purchase_price = document.querySelector('[data-max_purchase_price]');
  const purchase_price_up_campaign_block = document.querySelector('[data-purchase_price_up_campaign_block]');
  const purchase_price_up = document.querySelector('[data-purchase_price_up]');
  const max_purchase_campaign_price = document.querySelector('[data-max_purchase_campaign_price]');
  if(parchase_price_block && max_purchase_price && purchase_price_up_campaign_block){
    if (current.purchase_price) {
      parchase_price_block.style.display = 'block';
      max_purchase_price.innerHTML = current.purchase_price;
      if(current.purchase_price_up && current.purchase_campaign_price){
        max_purchase_price.style.textDecoration = "line-through";
        purchase_price_up_campaign_block.style.display = 'block';
        purchase_price_up.innerHTML = current.purchase_price_up;
        max_purchase_campaign_price.innerHTML = current.purchase_campaign_price;
      } else {
        max_purchase_price.style.textDecoration = "none";
        purchase_price_up_campaign_block.style.display = 'none';
        purchase_price_up.innerHTML = "";
        max_purchase_campaign_price.innerHTM = "";
      }
    }else {
      max_purchase_price.style.textDecoration = "none";
      parchase_price_block.style.display = 'none';
      purchase_price_up_campaign_block.style.display = 'none';
      max_purchase_price.innerHTML = "";
    }
    
    const e1 = document.querySelector('.product-sticky-form__image');
    if(e1) {
      e1.setAttribute("src", current.featured_image?.src);
      e1.setAttribute("alt", current.featured_image?.alt);
    }
  }

  // カートボタン
  if (metafields) {
    let cartBtnDisable = false;
    let cartBtnText = "";
    let now = new Date();
    let prod_info_open_date = (metafields.prod_info_open_date) ? new Date(metafields.prod_info_open_date) : undefined;
    if(prod_info_open_date > now){
      cartBtnDisable = true;
    }
    let reserve_start_date = (metafields.reserve_start_date) ? new Date(metafields.reserve_start_date) : undefined;
    let ec_sales_start_date = (metafields.ec_sales_start_date) ? new Date(metafields.ec_sales_start_date) : undefined;
    let ec_sales_end_date = (metafields.ec_sales_end_date) ? new Date(metafields.ec_sales_end_date) : undefined;
    if(metafields.ec_sales_end_date && now >= ec_sales_end_date){
      cartBtnText = "販売を終了しました";
      cartBtnDisable = true;
    } else {
      if(reserve_start_date && ec_sales_start_date && reserve_start_date < now && now < ec_sales_start_date){
        let upper_limit_reservation = parseInt(metafields.upper_limit_reservation ? metafields.upper_limit_reservation : "0");
        let reservation_sold = parseInt(metafields.reservation_sold ? metafields.reservation_sold : "0");
        let available_reservations = upper_limit_reservation - reservation_sold;
        if(Math.max(0, available_reservations) + Math.max(0, current.inventory_quantity) > 0){
          cartBtnText = "ただいま予約受付中です";
          cartBtnDisable = false;
        } else {
          cartBtnText = "ご予約完売いたしました";
          cartBtnDisable = true;
        }
      } else {
        if(ec_sales_start_date && now >= ec_sales_start_date){
          if (current.inventory_quantity > 0){
            cartBtnText = "カートに入れる";
            cartBtnDisable = false;
          } else {
            let upper_limit_reservation = parseInt(metafields.upper_limit_reservation ? metafields.upper_limit_reservation : "0");
            let reservation_sold = parseInt(metafields.reservation_sold ? metafields.reservation_sold : "0");
            let available_reservations = upper_limit_reservation - reservation_sold;
            if (available_reservations > 0){
              cartBtnText = "ただいま予約受付中です";
              cartBtnDisable = false;
            } else {
              cartBtnText = "ただいま売り切れ中です";
              cartBtnDisable = true;
            }
          }
        } else {
          cartBtnText = "販売開始前";
          cartBtnDisable = true;
        }
      }
    }
    document.querySelectorAll('[data-add-to-cart]').forEach(e => {
      e.classList.remove('disabled');
      e.disabled = cartBtnDisable;
      if(cartBtnDisable){e.classList.add('disabled');}
    });
    document.querySelectorAll('[data-add-to-cart-text]').forEach(e => {
      e.textContent = cartBtnText;
    });
  }
}

// ポイント更新
async function updatePoint(current){
  if(!current){
    return;
  }
  const target = document.querySelector('[data-point]');
  if(!current || !target){
    return;
  }
  
  let price = window.WSAIO?.pre_checkout_data?.product_regular_discount?.regular_price;
  if(price != undefined){
    price = Math.floor(price);
  } else {
    price = parseFloat(current.price) / 100.0;
  }
  const items = [{
    variant_id: current.id,
    product_id: current.product_id,
    line_price: price
  }];
  const response = await fetch(`/apps/recore/earn_point`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items})
  });
  if(!response || !response.ok){
    console.error("recore/earn_pointのfetchに失敗しました。");
    console.error(JSON.stringify({items}));
    target.innerHTML = 0;
    return;
  }
  const data = await response?.json().catch(() => null);
  let wsaio_price = window.WSAIO?.pre_checkout_data?.product_regular_discount?.regular_price;
  if(wsaio_price != undefined && Math.floor(wsaio_price) != price){
    // whole sale価格と違う場合は再度ポイント更新
    updatePoint(current);
    return;
  }
  let is_customer = (window.Shopify.customer_id) ? window.Shopify.customer_id != "" : false;
  if(data.items && data.items.length > 0 && data.items[0]?.amount != undefined){
    if(is_customer && data.items[0]?.is_on_sale && data.items[0]?.sale_amount != undefined){
      target.innerHTML = data.items[0]?.sale_amount;
    } else {
      target.innerHTML = data.items[0]?.amount;
    }
  } else {
    target.innerHTML = 0;
  }
  const compare_target = document.querySelector('[compare-data-point]');
  if(compare_target){
    // Check if pointup_flg metafield exists to suppress strikethrough display
    const hasPointupFlg = current.metafields && (current.metafields.pointup_flg == "1");
    if(!hasPointupFlg && is_customer && data.items && data.items.length > 0 && data.items[0]?.amount != undefined && data.items[0]?.is_on_sale){
      compare_target.innerHTML = data.items[0]?.amount;
      compare_target.style.display = "inline";
    } else {
      compare_target.innerHTML = 0;
      compare_target.style.display = "none";
    }
  }
}

// 延長保証セレクタを表示するかどうか
function isVisibleExtendedWarrantySelector(variant){
  let price = parseFloat(variant.price) / 100.0;
  const thres = window.theme.settings.lower_limit_price_for_extended_warranty;
  let text = variant.metafields.prod_warranty_period;
  let warrantyInYears = 0;
  if(text){
    // 例: "1Y", "18M", "6M", "2Y", "24M" などに対応
    const yearMatch = text.match(/(\d+)\s*Y/);
    const monthMatch = text.match(/(\d+)\s*M/);
    if(yearMatch) {
      warrantyInYears = parseInt(yearMatch[1], 10);
    } else if(monthMatch) {
      warrantyInYears = parseInt(monthMatch[1], 10) / 12;
    }
    if(
      variant.metafields.option_id == 1 &&
      price >= thres &&
      warrantyInYears >= 1
    ){
      return true;
    }
  }
  return false;
}

// 延長保証HTML取得
function getExtendedWarrantyHtml(current){
  if(!current){
    return "";
  }
  let price = parseFloat(current.price) / 100.0;

  // カート内での同一商品および延長保証の確認
  let is_same_variant_in_cart = false
  let contain_warranty = false  
  const items = window.WSAIO?.cart_object?.items;
  if(items){
    items.forEach(line_item => {
      if(line_item.variant_id == current.id){
        is_same_variant_in_cart = true;
        if(line_item.properties['_warranty_added'] == 'yes'){
          contain_warranty = true;
        }
      }
    });
  }

  let html = "";
  if(isVisibleExtendedWarrantySelector(current)){
    if(!is_same_variant_in_cart){
      // 同一商品がカートにない場合
      html = `
            <option value="no" price="">保証期間を5年間に延長できます！(選択)</option>
            <option value="yes" class="warranty-option" price="${Math.floor(price * 0.05)}">
              イイ音！延長保証サービス（5年）(${theme.Currency.formatMoney(Math.floor(price * 0.05) * 100, theme.moneyFormat)})
            </option>
            `;
    } else {
      if(contain_warranty){
        // 同一商品に延長保証が適用されている場合
        html = `
              <!-- 同一商品に延長保証が適用されている場合 -->
              <option value="no" price="" disabled>保証期間を5年間に延長できます！(選択)</option>
              <option value="yes" class="warranty-option" price="${Math.floor(price * 0.05)}">
                イイ音！延長保証サービス（5年）(${theme.Currency.formatMoney(Math.floor(price * 0.05) * 100, theme.moneyFormat)})
              </option>
              `;
      } else {
        // 同一商品に保証が適用されていない場合
        html = `
              <option value="no" price="">保証期間を5年間に延長できます！(選択)</option>
              <option value="yes" class="warranty-option" price="" disabled>
                延長保証を追加するには、カートに入っている同一商品を削除してから追加してください！
              </option>
              `;
      }
    }
  }
  return html;
}

// 延長保証金額更新
function updateExtendedWarranty(current){
  if(!current){
    return;
  }
  let html = getExtendedWarrantyHtml(current);
  document.querySelectorAll(".warranty-selector").forEach(el => {
    el.innerHTML = html;
    if(isVisibleExtendedWarrantySelector(current)){
      el.style.display = "block";
      if(el.options[el.selectedIndex]){
        el.nextElementSibling.value = el.options[el.selectedIndex]?.getAttribute('price');
        el.nextElementSibling.setAttribute('name', (el.nextElementSibling.value != '') ? 'properties[_warranty_price]' : '');
      }
    } else {
      el.style.display = "none";
      el.nextElementSibling.value = "";
      el.nextElementSibling.setAttribute('name', '');
    }
  });
}

// 店舗別在庫状況を設定
async function productStockOfShop(current, variants, shipping_date_limit) {
  const shipping_date_limit_el = document.querySelector("[data-shipping-date-limit]");
  if(shipping_date_limit_el){
    shipping_date_limit_el.innerHTML = "";

    // 中古品対応
    const product_el = document.querySelector(".product-section");
    if(product_el && product_el.dataset.productType === "中古"){
      const product_title = product_el.dataset.productTitle;
      const shop_names = product_title.match(/\【.*?\】/g);
      let stocked_shop_ids = [];
      for(const shop_name of shop_names){
        if(shop_name.includes("秋葉原")){
          stocked_shop_ids.push(4);
        }
        if(shop_name.includes("名古屋")){
          stocked_shop_ids.push(7);
        }
        if(shop_name.includes("日本橋")){
          stocked_shop_ids.push(18);
        }
        if(shop_name.includes("仙台")){
          stocked_shop_ids.push(122);
        }
      }
      updateShippingDateLimit(shipping_date_limit, stocked_shop_ids, shipping_date_limit_el);
      return;
    }
  }

  let shop_ids = [4, 18, 7, 122]; //秋葉原, 大阪日本橋, 名古屋大須, 仙台駅前の順番
  let stocked_shop_url = {4:"/pages/shop_akb/", 18:"/pages/shop_npb/", 7:"/pages/shop_osu/", 122:"/pages/shop_snd/"};
  let default_shop_names = {4:"秋葉原店", 18:"大阪日本橋本店", 7:"名古屋大須店", 122:"仙台駅前店" };
  const table = document.querySelector("[data-shopstock-table-body]");
  if(table){
    let html = "";
    shop_ids.forEach(id => {
      html += `
        <tr>
          <td class="shop-stock-td"><a href="${stocked_shop_url[id]}" target="_blank" rel="noopener" class="shopstock-list__name">${default_shop_names[id]}</a></td>
          <td class="shop-stock-td">×</td>
          <td class="shop-stock-td">×</td>        
        </tr>`
    });
    table.innerHTML = html;
  }
  
  const sku_id = current.metafields?.sku_id;
  const site_url = `https://s3.ap-northeast-1.amazonaws.com/image.www.tmsys.biz/tmg_site.json`;
  const stock_url = `https://s3.ap-northeast-1.amazonaws.com/image.www.tmsys.biz/productstock`;
  const prod_stock_args = [];
  variants.forEach(variant => {
    if(variant.metafields?.sku_id && variant.metafields?.sku_id != sku_id){
      prod_stock_args.push({sku_id: variant.metafields?.sku_id, display_open_date: new Date(variant.metafields?.display_open_date)});
    }
  });
  const fetches = [];
  fetches.push(fetch(site_url));
  fetches.push(fetch(`${stock_url}/${sku_id}.json`));
  prod_stock_args.forEach(prod_stock_arg => {
    fetches.push(fetch(`${stock_url}/${prod_stock_arg.sku_id}.json`));
  });
  const response = await Promise.all(fetches);
  if(!response[0].ok){
    console.error(`s3店舗一覧のfetchに失敗しました: ${site_url}`);
    return;
  }
  const json_promises = [response[0].json()];
  if(response[1].ok){
    json_promises.push(response[1].json());
  } else {
    console.error(`s3在庫状況のfetchに失敗しました: ${stock_url}/${sku_id}.json`);
  }
  const display_open_dates = {};
  for(let i=2; i<response.length; i++){
    if(response[i].ok){
      display_open_dates[json_promises.length] = prod_stock_args[i-2].display_open_date;
      json_promises.push(response[i].json());
    }
  }
  const data = await Promise.all(json_promises);
  let site = undefined, stock = undefined, prod_stocks = [];
  for(let i=0; i<data.length; i++){
    if(i == 0){
      site = data[0];
    } else {
      if(i == 1 && response[1].ok){
        stock = data[i];
      } else {
        prod_stocks.push({stock: data[i], display_open_date: display_open_dates[i]});
      }
    }
  }
  let now = new Date();
  const stockThreshold = document.querySelector(".product-single__shopstock")?.dataset?.stockThreshold;
  let html = "";
  let stocked_shop_ids = [];
  shop_ids.forEach(id => {
    const site_data = site.data.find(data => {return data.id === id;});
    if(!site_data){
      return;
    }
    let stock_desc = "×"; //売り切れ
    let audition_desc = "×" //試聴機なし
    if(stock){
      const stock_data = stock.data.find(data => {return data.tmg_site === id;});
      if(stock_data){    
        if(stock_data.free_qty > 0){
          stocked_shop_ids.push(stock_data.tmg_site);
          if(stockThreshold && stock_data.free_qty <= parseInt(stockThreshold)){
            stock_desc = "△"; //残りわずか
          } else {
            stock_desc = "○"; //在庫あり
          }
        }
        const display_open_date = new Date(current.metafields?.display_open_date);
        if(now >= display_open_date && (stock_data.display_qty > 0 || stock_data.sample_qty > 0)){
          audition_desc = "○" //試聴機あり
        }
      }
    }
    if(audition_desc === "×"){
      prod_stocks.forEach(prod_stock => {
        const prod_stock_data = prod_stock.stock.data.find(data => {return data.tmg_site === id;});
        if(now >= prod_stock.display_open_date && prod_stock_data && (prod_stock_data.display_qty > 0 || prod_stock_data.sample_qty > 0)){
          audition_desc = "○" //試聴機あり
        }
      });
    }
    html += `
      <tr>
        <td class="shop-stock-td"><a href="${stocked_shop_url[id]}" target="_blank" rel="noopener" class="shopstock-list__name">${site_data.site_official_name}</a></td>
        <td class="shop-stock-td">${stock_desc}</td>
        <td class="shop-stock-td">${audition_desc}</td>        
      </tr>`;
  });
  site.data.forEach(site_data => {
    if(shop_ids.includes(site_data.id)){
      return;
    }
    if(site_data.id == 221){ //ゲーミング店舗は除外
      return;
    }
    let stock_desc = "×"; //売り切れ
    let audition_desc = "×" //試聴機なし
    if(stock){
      const stock_data = stock.data.find(stock_data => {return stock_data.tmg_site === site_data.id;});
      if(stock_data){
        if(stock_data.free_qty > 0){
          stocked_shop_ids.push(stock_data.tmg_site);
          if(stockThreshold && stock_data.free_qty <= parseInt(stockThreshold)){
            stock_desc = "△"; //残りわずか
          } else {
            stock_desc = "○"; //在庫あり
          }
        }
        const display_open_date = new Date(current.metafields?.display_open_date);
        if(now >= display_open_date && (stock_data.display_qty > 0 || stock_data.sample_qty > 0)){
          audition_desc = "○" //試聴機あり
        }
      }
    }
    if(audition_desc === "×"){
      prod_stocks.forEach(prod_stock => {
        const prod_stock_data = prod_stock.stock.data.find(data => {return data.tmg_site === site_data.id;});
        if(now >= prod_stock.display_open_date && (prod_stock_data.display_qty > 0 || prod_stock_data.sample_qty > 0)){
          audition_desc = "○" //試聴機あり
        }
      });
    }
    html += `
      <tr>
        <td class="shop-stock-td">${site_data.site_official_name}</td>
        <td class="shop-stock-td">${stock_desc}</td>
        <td class="shop-stock-td">${audition_desc}</td>        
      </tr>`;
  });
  if(table){
    table.innerHTML = html;
  }
  updateShippingDateLimit(shipping_date_limit, stocked_shop_ids, shipping_date_limit_el);
}
  
// 出荷日時リミットを更新
function updateShippingDateLimit(shipping_date_limit, stocked_shop_ids, shipping_date_limit_el){  
  if(shipping_date_limit && stocked_shop_ids.length > 0 && shipping_date_limit_el){
    shopShippingDateLimits = {
      4: shipping_date_limit_el.dataset?.shippingDateLimitAkb,
      7: shipping_date_limit_el.dataset?.shippingDateLimitOsu,
      18: shipping_date_limit_el.dataset?.shippingDateLimitNpb,
      122: shipping_date_limit_el.dataset?.shippingDateLimitSnd,
    }
    let shippingDateLimit = shipping_date_limit_el.dataset?.shippingDateLimit;
    if(stocked_shop_ids.length == 1 && shopShippingDateLimits.hasOwnProperty(stocked_shop_ids[0])){
      shippingDateLimit = shopShippingDateLimits[stocked_shop_ids[0]];      
    }
    const now = new Date();
    let limit_date = new Date();
    limit_date.setHours(shippingDateLimit, 0, 0, 0);
    if(now < limit_date){
      let diff = Math.ceil((limit_date.getTime() - now.getTime()) / (60 * 1000));
      const diff_hour = Math.floor(diff / 60) > 0 ? `${Math.floor(diff / 60)}時間` : "";
      const diff_min = `${ diff % 60 }分`;
      shipping_date_limit_el.innerHTML = `在庫有りの場合、${diff_hour}${diff_min}以内のご注文で本日出荷`;
    } else {
      shipping_date_limit_el.innerHTML = `${shippingDateLimit}時までのご注文は、年中無休で即日出荷`;
    }
  }
}

// 商品カードのポイントフェッチ
async function fetchProductCardPoints(targets){
  if(targets.length == 0){
    return;
  }
  const items = [];
  const el_parents = [];
  for(let target of targets){
    const el_parent = target.closest(".grid-product");
    if(!el_parent){
      continue;
    }
    el_parents.push(el_parent);
    const product_id = el_parent.dataset.productId;
    const variant_id = el_parent.dataset.minPriceVariantId;
    let price = target.querySelector(".product__price.on-sale")?.textContent;
    if(price){
      price = price.slice(1).replace(",", "");
    } else {
      if(target.querySelector("[data-price]")?.getAttribute("data-price") !== undefined){
        price = target.querySelector("[data-price]").getAttribute("data-price") / 100;
      } else {
        const collDSpan = target.querySelector('.coll_d');
        if (collDSpan) {
          let fullText = collDSpan.textContent;
          const originalPriceSpan = collDSpan.querySelector('.grid-product__price--original');
          if (originalPriceSpan) {
            fullText = fullText.replace(originalPriceSpan.textContent, '');
          }
          price = fullText.replace(/[^\d]/g, '');
        } else {
          const product_price_span = el_parent.querySelector('[data-product-price]');
          if(product_price_span !== undefined && product_price_span !== null){
            price = product_price_span.textContent.replace(/[^\d]/g, '');
          }
        }
      }
    }
    price = parseFloat(price);
    items.push({
      variant_id: variant_id,
      product_id: product_id,
      line_price: price
    });
  }
  const response = await fetch(`/apps/recore/earn_point`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items})
  });
  if(!response || !response.ok){
    console.error("recore/earn_pointのfetchに失敗しました。");
    console.error(JSON.stringify({items}));
    return;
  }
  const data = await response?.json().catch(() => null);
  let is_customer = (window.Shopify.customer_id) ? window.Shopify.customer_id != "" : false;
  for(let i=0; i<data.items.length&&i<el_parents.length; i++){
    const el_point = el_parents[i].querySelector(".product-single__point");
    // Check if pointup_flg data attribute exists to suppress strikethrough display
    const hasPointupFlg = el_parents[i].dataset.pointupFlg == "1";
    if(is_customer && data.items[i]?.is_on_sale && data.items[i]?.sale_amount != undefined){
      el_point.innerHTML = "";
      if(!hasPointupFlg && data?.items[i]?.amount != undefined){
        el_point.innerHTML = `<span compare-data-point class="product-single__point product-single__compare-point">${data.items[i].amount}</span>`
      }
      el_point.innerHTML += data.items[i]?.sale_amount;
    } else if(data?.items[i]?.amount != undefined){
      el_point.innerHTML = data.items[i].amount;
    } else {
      el_point.innerHTML = 0;
    }
  }
}
function registerProductCardPointObserver(els){
  if(els.length == 0){
    return;
  }
  let targets = [];
  let timeoutHandle = undefined;
  const observer = new MutationObserver(records => {
    for(let record of records){
      if(record.attributeName == "class" &&
        record.target.classList.contains("wsdapp") &&
        targets.indexOf(record.target) < 0){
        targets.push(record.target);
      }
    }
    if(timeoutHandle){
      window.clearTimeout(timeoutHandle);
    }
    timeoutHandle = window.setTimeout(()=>{
      fetchProductCardPoints(targets);
      targets = [];
    }, 1000);
  });
  els.forEach(el => {
    observer.observe(el, {attributes:true});
  });
}

// コレクションページの遷移URLに販売中フラグを追加
document.addEventListener('DOMContentLoaded', () => {
  const allLinks = document.querySelectorAll('a[href*="collections"]');
  const filterParamKey = 'filter.p.m.custom.is_on_sale';
  const filterParamValue = '販売中';
  allLinks.forEach(function(link) {
    if(link.parentNode.classList.contains("page") ||
    link.parentNode.classList.contains("prev") ||
    link.parentNode.classList.contains("next") ||
    link.parentNode.classList.contains("tag--remove")) {
      return;
    }
    const href = link.getAttribute('href');
    if (href) {
      const url = new URL(href, window.location.origin);
      const params = url.searchParams;
      if (!params.has(filterParamKey)) {
          params.set(filterParamKey, filterParamValue);
          link.setAttribute('href', url.toString());
      }
    }
  });
});

